import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ConsoleCloudAccountPoolSetupDialog } from '../pool/pool.dialog';
import { CloudAccountListComponent } from '@serengeti/serengeti-cloud-account';

@Component({
  selector: 'app-cloud-account-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ConsoleCloudAccountListComponent implements OnInit {

	@ViewChild('accountList', {static: false}) accountList: CloudAccountListComponent;

  constructor(
    private dialog: MatDialog
  ) { }

  ngOnInit() {
  }

  onPoolChangingRequested($event: any) {
		const poolDialogRef = this.dialog.open(ConsoleCloudAccountPoolSetupDialog, {
			width: '80%',
			height: '80%',
			data: $event
		});

		poolDialogRef.afterClosed().subscribe(selectedPool => {
      this.accountList.doSearch();
    });
  }
}
